// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Custom Theme
const customTheme = {
  dark: false,
  colors: {
    primary: '#B8AFA6', // Replace with your desired primary color
    secondary: '#8BB7B1', // Replace with your desired secondary color
    // Add more custom colors as needed
  },
};

export default createVuetify({
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme,
    },
  },
});